import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-external-link",
  "use": "icon-external-link-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-external-link\">\n    <path d=\"M8.5 2V3H11.2812L5.14062 9.14062L5.85938 9.85938L12 3.71875V6.5H13V2H8.5ZM2 4V13H11V6.5L10 7.5V12H3V5H7.5L8.5 4H2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol